import { receiveCurrentUser } from './user_actions.js'

export function handleLoadMeSuccess(res) {
  return (dispatch, getState) => {
    const responseData = res.data
    const currentUser = responseData.data.current_user
    dispatch(receiveCurrentUser(currentUser))
  }
}

export function handleLoadMeError(err) {
  return (dispatch, getState) => {
    switch (err.status) {
      case 422:
        const errors = err.data.errors
        // do nothing
        break

      default:
      // do nothing
    }
  }
}
